import Vue from 'vue'
import App from './App.vue'
import router from "./route.js";
Vue.config.productionTip = false

router.afterEach((to, from) => {
  if(to.query.id){
    let ids =  to.query.id;
    setTimeout(()=>{
      window.onload = function(){
        document.getElementById(ids).scrollIntoView(true);
      }
      if(!!from.name){
        document.getElementById(ids).scrollIntoView(true);
      }
    },0)
  }else{
    window.scrollTo(0,0)
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
